import { updateMemberOrganization } from 'admin/actions/member-organization';
import Headings from 'admin/components/atoms/Headings';
import Table from 'admin/components/atoms/Table';
import ToggleSwitch from 'admin/components/atoms/ToggleSwitch';
import Pager from 'admin/components/shared/Pager';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Loader from '../../atoms/Loader';

const LoaderWrapper = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
`;

const SearchResultInfo = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
`;
const SearchResultTitle = styled(Headings.h5)`
  margin: 0;
  margin-left: 15px;
  padding: 16px 0;
`;
const SearchResultCount = styled.span`
  flex: 1;
`;

const MemberOrganizationListTable = ({
  privateMoneyId,
  memberOrgs,
  refresh,
  isLoading,
  pagination,
  onChangePage,
}) => {
  const handlerToggleSwitch = (checked, org, privateMoneyId) => {
    updateMemberOrganization(privateMoneyId, org.code, !checked).then(() => refresh());
  };

  return (
    <div>
      <SearchResultInfo>
        <SearchResultTitle>検索結果</SearchResultTitle>
        {memberOrgs !== null && <SearchResultCount>件数：{memberOrgs?.count}</SearchResultCount>}
      </SearchResultInfo>
      {isLoading ? (
        <LoaderWrapper>
          <Loader type="Oval" width={50} height={50} />
        </LoaderWrapper>
      ) : (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.Cell size="2">組織コード</Table.Cell>
              <Table.Cell size="2">組織名</Table.Cell>
              <Table.Cell size="2">本店</Table.Cell>
              <Table.Cell size="2">住所</Table.Cell>
              <Table.Cell size="1">電話番号</Table.Cell>
              <Table.Cell size="2">メールアドレス</Table.Cell>
              <Table.Cell size="1">加盟</Table.Cell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {memberOrgs?.rows?.map((org) => (
              <Table.Row key={org.code} style={{ background: org.disable ? '#ddd' : 'unset' }}>
                <Table.Cell>
                  {<Link to={`/organizations/${org.code}`}>{org.code}</Link>}
                </Table.Cell>
                <Table.Cell wordBreak="break-word">{org.name}</Table.Cell>
                <Table.Cell wordBreak="break-word">{org.head_office?.name ?? '-'}</Table.Cell>
                <Table.Cell wordBreak="break-word">
                  {org.head_office_metadata?.address ?? '-'}
                </Table.Cell>
                <Table.Cell>{org.head_office_metadata?.tel ?? '-'}</Table.Cell>
                <Table.Cell>{org.head_office_metadata?.email ?? '-'}</Table.Cell>
                <Table.Cell>
                  {
                    <ToggleSwitch
                      key={org.code}
                      checked={!org.disable}
                      onChange={(checked) => handlerToggleSwitch(checked, org, privateMoneyId)}
                    />
                  }
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row noBorder>
              <Table.Cell colSpan={7} align="center" styles={{ paddingTop: '16px' }}>
                <Pager pagination={pagination} onChangePage={onChangePage} />
              </Table.Cell>
            </Table.Row>
          </Table.Footer>
        </Table>
      )}
    </div>
  );
};

export default MemberOrganizationListTable;
